import { useTranslation } from 'react-i18next'

import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
} from '@mui/material'

import ArrowForwardIcon from '@mui/icons-material/ArrowForward'

import { TLGLink } from '@components/TLGLink'
import { TLGTypography } from '@components/TLGTypography'

import { cardActionsSx, cardContentSx, cardSx, titleSx } from './styles'

interface IPressPostProps {
  imageUrl: string
  title: string
  url: string
}

const PressPost = ({ imageUrl, title, url }: IPressPostProps) => {
  const { t } = useTranslation()

  return (
    <TLGLink
      data-testid="press-post-link"
      href={url}
      rel="noopener noreferrer"
      target="_blank"
      underline="none"
    >
      <Card sx={cardSx} data-testid="press-post">
        <CardMedia
          data-testid="press-post-image"
          component="img"
          loading="lazy"
          alt={t('Press Post Image')}
          image={imageUrl}
        />
        <CardContent sx={cardContentSx}>
          <TLGTypography
            data-testid="press-post-title"
            responsiveVariant={{ xs: 'h6', md: 'h5' }}
            title={title}
            component="a"
            sx={titleSx}
          >
            {title}
          </TLGTypography>
        </CardContent>
        <CardActions sx={cardActionsSx}>
          <Button
            data-testid="press-post-read-article-button"
            variant="outlined"
            size="medium"
            endIcon={<ArrowForwardIcon />}
            href={url}
            rel="noopener noreferrer"
            target="_blank"
          >
            {t('Read Article')}
          </Button>
        </CardActions>
      </Card>
    </TLGLink>
  )
}

export { PressPost }
